import React from "react";
import { Button, Layout, message, Popover, Tooltip } from "antd";
import logo from "static/gravity-icon.png";
import userBlank from "static/user-blank.png"; 
import styles from "./layoutWrapper.module.less";
import LeftSidebar from "./components/LeftSidebar";
import useMixPanel from "customHooks/useMixPanel";
import { MIX_PANEL_EVENTS } from "constants/mix-panel-events";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserLogoutRequest } from "./requests";

const { Sider, Content, Header } = Layout;

const getSidebarBasedOnType = (navigationType) => {
  switch (navigationType) {
    case "portalNav":
      return (
        <Sider
          className={styles.navBar}
          width={200}
        >
          <LeftSidebar />
        </Sider>
      );
    default:
      return null;
  }
};

const LayoutWrapper = ({ children, leftNavigationType }) => {
  const { event } = useMixPanel();
  const sessionUserData = useSelector(
    (globalState) => globalState.session.user
  );
  const { firstName, lastName, email, profileImageUrl } = sessionUserData;
  const history = useHistory();

  const handleLogout = async () => {
    try {
      const res = await getUserLogoutRequest();
      if (res.data.success) {
        localStorage.clear();
        history.push("/auth/login");
        message.success("Logged out successfully");
      } else message.error("Some Error Occured");
    } catch (err) {
      message.error("Some Error Occured");
    }
  };

  const openWhatsappChat = () => {
    event(MIX_PANEL_EVENTS.WHATSAPP_SUPPORT_CLICKED, { userEmail: email });
    window.open(
      "https://wa.me/916366992879?text=Hello%20FrontBase%20Support%2C%20I%20need%20help%20with...",
      "_blank"
    );
  }

  const openBookDemoForm = () => {
    event(MIX_PANEL_EVENTS.OPEN_DEMO_LINK, { userEmail: email });
    window.open(
      "https://tidycal.com/vineetvk01/15-minute-meeting",
      "_blank"
    );
  }

  return (
    <Layout className={styles.layout}>
      <Header className={styles.topHeader}>
        <div className={styles.leftHeader}>
          <div className={styles.logo}>
            <img src={logo} alt="" onClick={() => history.push("/portals")} /> 
            <p onClick={() => history.push("/portals")}>FrontBase</p>
            <Tooltip title="This is a closed beta version of FrontBase">
              <span className={styles.phase}>CLOSE BETA</span>
            </Tooltip>
          </div>
        </div>
        <div>
          <Button type="text" onClick={openWhatsappChat} style={{ marginRight: "20px" }}>
            <i className="ri-whatsapp-line" style={{ marginRight: "6px", fontSize: "16px" }} />  Connect Now
          </Button>
          
          <Popover
            className={styles.profileNav}
            getPopupContainer={(trigger) => trigger.parentNode}
            placement="bottomRight"
            content={() => (
              <div className={styles.menuOptions}>
                <div className={styles.option} onClick={openWhatsappChat}>
                  <i className="ri-customer-service-line" /> Support (Contact Us)
                </div>
                <div className={styles.option} onClick={openBookDemoForm}>
                  <i className="ri-video-chat-line" /> Book a Demo
                </div>
                <div
                  className={styles.option}
                  onClick={() => history.push("/settings")}
                >
                  <i className="ri-settings-3-line" />Settings
                </div>
                <div className={styles.option} onClick={handleLogout}>
                  <i className="ri-logout-circle-r-line" /> Logout
                </div>
              </div>
            )}
            title={() => {
              return (
                <div className={styles.userPopoverTitle}>
                  <img
                    className={styles.userImage}
                    src={profileImageUrl ? profileImageUrl : userBlank}
                    alt=""
                  />
                  <div>
                    <div>{`${firstName} ${lastName}`}</div>
                    <div className={styles.userEmail}>{email}</div>
                  </div>
                </div>
              );
            }}
            trigger="click"
            arrowPointAtCenter={true}
          >
            <img
              className={styles.profileImage}
              src={profileImageUrl ? profileImageUrl : userBlank}
              alt=""
            />
          </Popover>
        </div>
        
      </Header>
      <Layout>
        {getSidebarBasedOnType(leftNavigationType)}
        <Layout>
          <Content className={styles.mainScreen}>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default React.memo(LayoutWrapper);
